module.exports = __webpack_public_path__ + "img/image15.a00a2df3.jpg";